import React from 'react';
import { Table, Button } from 'antd';
import moment from 'moment';
import { Link } from 'react-router-dom';

import Breadcrumbs from '@sp/client/components/Breadcrumbs';
import NavBar from '@sp/client/components/NavBar';

import s from './style.less';

class CustomerPlans extends React.Component {
  state = {
    list: [],
  };

  componentDidMount() {
    this.fetchList();
  }

  breadcrumbs = [{ name: 'Home' }];

  columns = [
    {
      title: 'Contract number',
      dataIndex: 'contractNumber',
      key: 'contract_number',
    },
    {
      title: 'Created',
      dataIndex: 'createdAt',
      key: 'created',
      render: date => moment(date).format('DD/MM/YYYY'),
    },
    {
      title: 'Paid',
      key: 'paid',
      render: (text, record) => <span>{record.payed ? 'Yes' : 'No'}</span>,
    },
    {
      title: '',
      key: 'action',
      dataIndex: 'id',
      render: (id, { cancelled }) => (
        <Link to={`/customer/plans/${id}`}>
          <Button
            type="primary"
            className={s.actionButton}
            disabled={cancelled}
          >
            Manage
          </Button>
        </Link>
      ),
    },
  ];

  fetchList = async () => {
    const list = await fetch('/customer/my-plans');
    this.setState({ list });
  };

  render() {
    const { list } = this.state;

    return (
      <NavBar withPadding>
        <Breadcrumbs paths={this.breadcrumbs} />
        <div className={s.title}>Request Your Service</div>
        <Table columns={this.columns} rowKey="id" dataSource={list} />
      </NavBar>
    );
  }
}

export default CustomerPlans;
